// import React from "react";
// import Layout from "../components/Layout";
// import ProductCard from "../components/ProductCard";
// import styles from "./Atlantic.module.css";

// const oliveProducts = [
//   {
//     // Маслины без кісточки 425 мл
//     title: "Маслини без кісточки\nOLIVE LAND",
//     image: "/assets/products/olive/olive-land-black-pitted-425.jpg",
//     weight: "425 мл | Ж/б банка",
//     description: "Фасовка: 12 шт | 144 ящ/палет",
//   },
//   {
//     // Маслины без кісточки 300 мл
//     title: "Маслини без кісточки\nOLIVE LAND",
//     image: "/assets/products/olive/olive-land-black-pitted-300.jpg",
//     weight: "300 мл | Ж/б банка",
//     description: "Фасовка: 12 шт | 196 ящ/палет",
//   },
//   {
//     // Оливки без кісточки 300 мл
//     title: "Оливки без кісточки\nOLIVE LAND",
//     image: "/assets/products/olive/olive-land-green-pitted-300.jpg",
//     weight: "300 мл | Ж/б банка",
//     description: "Фасовка: 12 шт | 196 ящ/палет",
//   },
// ];

// const Olive = () => (
//   <Layout>
//     <h2 className={styles.heading}>Оливки</h2>
//     <div className={styles.grid}>
//       {oliveProducts.map((p, i) => <ProductCard key={i} {...p} />)}
//     </div>
//   </Layout>
// );

// export default Olive;


import React from "react";
import Layout from "../components/Layout";
import ProductCard from "../components/ProductCard";
import styles from "./Atlantic.module.css";
import { useLanguage } from "../i18n/LanguageContext";

const Olive = () => {
  const { t } = useLanguage();

  const oliveProducts = [
    {
      title: t("olive.products.black425.title"),
      image: "/assets/products/olive/olive-land-black-pitted-425.jpg",
      weight: t("olive.products.black425.weight"),
      description: t("olive.products.black425.description"),
    },
    {
      title: t("olive.products.black300.title"),
      image: "/assets/products/olive/olive-land-black-pitted-300.jpg",
      weight: t("olive.products.black300.weight"),
      description: t("olive.products.black300.description"),
    },
    {
      title: t("olive.products.green300.title"),
      image: "/assets/products/olive/olive-land-green-pitted-300.jpg",
      weight: t("olive.products.green300.weight"),
      description: t("olive.products.green300.description"),
    },
  ];

  return (
    <Layout>
      <h2 className={styles.heading}>{t("olive.title")}</h2>

      <div className={styles.grid}>
        {oliveProducts.map((p, i) => (
          <ProductCard key={i} {...p} />
        ))}
      </div>
    </Layout>
  );
};

export default Olive;
